// tslint:disable-next-line:no-any
export const isNullOrUndefined = (arg: any): boolean => {
  return arg == null;
};
